// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"46428684","104":"98b40247","890":"efd6e286","983":"6ff8e956"}[chunkId] + ".chunk.css";
};